import { render, staticRenderFns } from "./SitemapList.vue?vue&type=template&id=12e497e2&scoped=true"
import script from "./SitemapList.vue?vue&type=script&lang=js"
export * from "./SitemapList.vue?vue&type=script&lang=js"
import style0 from "./SitemapList.vue?vue&type=style&index=0&id=12e497e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e497e2",
  null
  
)

export default component.exports